export default function nationalizeTel(n) {
  return '233'+n.slice(-9);
}